/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-sequences */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-case-declarations */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable eqeqeq */
/* eslint-disable no-debugger */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import { AnimatePresence, motion } from 'framer-motion';
import React, {
    useEffect, useState, useRef, useCallback, useContext,
} from 'react';
import { connect } from 'react-redux';
import SlidingPane from 'react-sliding-pane';
import { UserActions } from '../../redux/actions/user.action';
import { userService } from '../../service/user.service';
import { distributorService } from '../../service/distributor.service';
import TableHeader from '../../TableHeader';
import CustomToast from '../../Components/AlertPopup';
import ItemSkeleton from '../../Components/Skeletons/itemSkeleton';
import FilterModal from './FilterModal';
import ListUsers from './ListUsers';
import Pagination from '../../Components/Pagination';
import HeaderContext from '../../Components/Context/HeaderContext';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

function AdminUsers({
    getUserList, UsersList, SortUser, handlePagination, AdminUserPagination,
}) {
    const [editpaneopen, seteditpaneopen] = useState(false);
    const [title, settitle] = useState(' OTP Verification Successful!');
    const [sort, setsort] = useState(false);
    const [sortType, setsortType] = useState('created_at+desc');
    const [alertShow, setalertShow] = useState(false);
    const [linksentPopup, setlinksentPopup] = useState(false);
    const [searchValue, setsearchValue] = useState('');
    const [isPaneOpen, setisPaneOpen] = useState(false);
    const [NoUser, setNoUser] = useState(false);
    const [showSuccess, setshowSuccess] = useState(false);
    const [isLoaded, setisLoaded] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [EditDAte, setEditDAte] = useState([]);
    const [threePL, setthreePL] = useState([]);
    const [territaryList, setterritaryList] = useState([]);
    const [render, setrender] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [color, setcolor] = useState(false);
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');
    const [isEditId, setisEditId] = useState('');
    const [loading, setloading] = useState(false);
    const [statusLoader, setstatusLoader] = useState('');
    const [nextPageHasData, setnextPageHasData] = useState(false);
    const [filter, setfilter] = useState(false);
    const [OpenPopup, setOpenPopup] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const [showPopup, setshowPopup] = useState(false);
    const [renderPage, setrenderPage] = useState(false);
    const [rolesData, setRolesData] = useState([]);
    const [manageUserList, setManageUserList] = useState([]);
    const [isUserList, setIsUserList] = useState(false);
    const [managers, setManagers] = useState();
    const [selected, setselected] = useState({
        role: [],
        threpl: [],
        territory: [],
        status: '',
        reporting_managers: [],
    });
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
    } = useContext(HeaderContext);
    const ref = useRef();
    /**
     * it will open sidebar modal
     */
    const handleOpen = () => {
        setisPaneOpen(true);
    };
    /**
     * Fetching user list
     */

    const handleFiletr = (url) => {
        if (url.length > 0 && filterValue !== url) {
            setisLoaded(true);
            setCurrentPage(1);
            setfilterValue(url);
        } else {
            setfilter(false);
            setfilterValue(url);
        }
    };

    const handleFetch = useCallback((() => {
        getUserList(currentPage, searchValue, filterValue, sortType).then((val) => {
            if (!val.error && val.data.success_status) {
                setHardRefresh(false);
                if (val.data.data.LastEvaluatedKey !== undefined) {
                    userService.UsersList(val.data.data.LastEvaluatedKey.account_id, searchValue, filterValue, sortType).then((resp) => {
                        if (resp?.data?.data?.Items.length > 0) {
                            setnextPageHasData(true);
                            setNoUser(false);
                            setisLoaded(false);
                            setfilter(false);
                        } else {
                            setNoUser(true);
                            setisLoaded(false);
                            setnextPageHasData(false);
                        }
                    });
                } else {
                    setfilter(false);
                    setisLoaded(false);
                    setnextPageHasData(false);
                }
            } else {
                SetErrorMessage(val.message);
                setcolorValue(!colorValue);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(!colorValue);
                }, 3000);
            }
            setisLoaded(false);
        });
    }), [currentPage, searchValue, filterValue, sortType]);

    const handleExport = useCallback((() => {
        userService.handleExport(searchValue, filterValue, sortType, exportSelected).then((val) => {
            if (val.data.success_status) {
                setshowPopup(true);
                settitle(val.data.message);
                setexportClick(false);
                setexportSelected('');
                if (val.data.url) {
                    window.open(val.data.url, '_blank');
                }
                setTimeout(() => {
                    settitle('');
                    setshowPopup(false);
                }, 3000);
            }
        }).catch((e) => {
            setexportSelected(false);
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const handleActivateOrDeactivate = (status, email) => {
        setactvloader(true);
        const payload = {
            admin_status: String(status),
        };
        if (OpenPopup === 'active') {
            userService.UserActiveOrDeactivateAccount(payload, email).then((res) => {
                if (res?.message?.status === 409) {
                    setManageUserList(res?.message?.data?.data);
                    setIsUserList(true);
                    setactvloader(false);
                } else if (!res.error && res.data.success_status) {
                    setOpenPopup('');
                    setactvloader(false);
                    setisLoaded(true);
                    settitle(res.data.message);
                    setIsUserList(false);
                    setshowPopup(true);
                    setTimeout(() => {
                        setshowPopup(false);
                    }, 4000);
                    handleFetch();
                } else {
                    setactvloader(false);
                }
            });
        } else {
            userService.ResetPassword(email).then((res) => {
                if (!res.error && res.data.success_status) {
                    setOpenPopup('');
                    setactvloader(false);
                    settitle(res.data.message);
                    setshowPopup(true);
                    setTimeout(() => {
                        setshowPopup(false);
                    }, 4000);
                } else {
                    setactvloader(false);
                    settitle(res.message);
                    setshowPopup(true);
                    setcolor(true);
                    setTimeout(() => {
                        setshowPopup(false);
                        setcolor(false);
                        OpenPopup('');
                    }, 4000);
                }
            });
        }
    };

    const handleDependency = async () => {
        const thpl = await userService.getthreepl();
        if (thpl.data.data.length > 0) {
            const arr = [];
            thpl.data.data.forEach((mng, i) => {
                mng.id = i;
                mng.label = mng.CITY;
                arr.push(mng);
            });
            setthreePL(arr);
        }
        const territry = await userService.getTerritory();
        if (territry.data.data.length > 0) {
            const arr = [];
            territry.data.data.forEach((mng, i) => {
                mng.label = mng.NAME,
                mng.id = i;
                arr.push(mng);
            });
            setterritaryList(arr);
        }
    };
    const getManagers = async () => {
        const arr = [];
        const manger = await userService.getManagers();
        if (manger.data.data.length > 0) {
            manger.data.data.forEach((mng, i) => {
                mng.id = i;
                arr.push(mng);
            });
        }
        setManagers(arr);
        return arr;
    };
    useEffect(() => {
        handleDependency();
        getManagers();
    }, []);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    const getRoles = async () => {
        const data = await distributorService.getRoles();
        setRolesData(data.data.data);
    };

    useEffect(() => {
        getRoles();
    }, []);

    function compareStatus(a, b) {
        if (a.admin_status < b.admin_status) {
            return -1;
        }
        if (a.admin_status > b.admin_status) {
            return 1;
        }
        return 0;
    }

    function comparelast(a, b) {
        if (a.last_name < b.last_name) {
            return -1;
        }
        if (a.last_name > b.last_name) {
            return 1;
        }
        return 0;
    }

    function compareRoles(a, b) {
        if (a.roles < b.roles) {
            return -1;
        }
        if (a.roles > b.roles) {
            return 1;
        }
        return 0;
    }
    function compare(a, b) {
        if (a.first_name < b.first_name) {
            return -1;
        }
        if (b.first_name > a.first_name) {
            return 1;
        }
        return 0;
    }
    const handleSort = useCallback((type) => {
        let data;
        if (UsersList.users) {
            const userListdata = UsersList.users.Items;

            switch (type) {
            case 'roles':
                const data3 = userListdata && userListdata.sort(compareRoles);
                if (sortType === 'roles') {
                    SortUser(data3.reverse());
                } else {
                    SortUser(data3);
                } break;
            case 'first_name':
                const data1 = userListdata && userListdata.sort(compare);
                if (sortType === 'first_name') {
                    SortUser(data1.reverse());
                } else {
                    SortUser(data);
                }
                break;
            case 'status':
                const data4 = userListdata && userListdata.sort(compareStatus);
                if (sortType === 'status') {
                    SortUser(data4.reverse());
                } else {
                    SortUser(data4);
                } break;
            case 'last_name':
                const data2 = userListdata && userListdata.sort(comparelast);
                if (sortType === 'last_name') {
                    SortUser(data2.reverse());
                } else {
                    SortUser(data2);
                } break;
            default: break;
            }
        }
    }, [sortType, UsersList]);
    useEffect(() => {
        handleSort();
    }, [handleSort]);
    const handlePageClick = async (data) => {
        setisLoaded(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };
    function OtpSuccessMeessage() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {title}
            </p>
        );
    }
    const handleClickOutside = (event) => {
        if (exportClick) {
            setexportClick(false);
        }
    };

    const previlegeassigned = AccessPrevilegesFunction('admin_users:create');
    const updateuserprevilegeassigned = AccessPrevilegesFunction('admin_users:update');
    const activateDeactivateprevilegeassigned = AccessPrevilegesFunction('admin_users:activate' || 'admin_users:deactivate');
    const resetprevilegeassigned = AccessPrevilegesFunction('admin_users:reset_password');

    return (
        <>
            {
                showPopup && (
                    <CustomToast
                        message={<OtpSuccessMeessage />}
                        open
                        color={color ? '#ED1C24' : undefined}
                    />
                )
            }
            <TableHeader
                setexportSelected={setexportSelected}
                exportClick={exportClick}
                exportSelected={exportSelected}
                setsearchValue={setsearchValue}
                filter={filter}
                setfilter={setfilter}
                setexportClick={setexportClick}
                setisEditId={setisEditId}
                setCurrentPage={setCurrentPage}
                searchValue={searchValue}
                previlegeassigned={previlegeassigned}
            />
            <div
                className="overflow-auto dropdown-menu sticky top-[0] left-0"
                style={{ height: 'calc(100vh - 298px)' }}
                onClick={() => handleClickOutside()}
            >

                {!isLoaded
                    ? (
                        <>
                            {UsersList.users && Object.keys(UsersList).length > 0 && UsersList.users.Items.length > 0
                            && (
                                <table className="w-full table-auto relative">
                                    <AnimatePresence>

                                        <motion.thead
                                            animate={{ opacity: 1, x: 0 }}
                                            initial={{ opacity: 0, x: -10 }}
                                            exit={{ opacity: 0, x: -10 }}
                                            transition={{ duration: 0.15 }}
                                            className="sticky top-0"
                                            style={{ zIndex: OpenPopup || exportClick ? '0' : '99' }}
                                        >
                                            <tr className="bg-[#555259] h-10">
                                                <th className="py-2.5 px-6 rounded-bl-lg rounded-tl-lg min-w-[158px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                        Employee Code
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7  min-w-[152px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        First Name
                                                        <a href="javascript:void(0)" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'first_name+asc' ? 180 : 0,
                                                                }}
                                                                src="/images/sort.svg"
                                                                // className={`${sortType === 'first_name' ? 'image-rotate' : ''}`}
                                                                alt="icon"
                                                                onClick={() => {
                                                                    // handleSort('first_name');
                                                                    if (sortType === 'first_name+asc') {
                                                                        setsortType('first_name+desc');
                                                                    } else if (sortType === 'first_name+desc') {
                                                                        setsortType('first_name+asc');
                                                                    } else { setsortType('first_name+asc'); }
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7  min-w-[152px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Last Name
                                                        <a href="#" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'last_name+asc' ? 180 : 0,
                                                                }}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    if (sortType === 'last_name+asc') {
                                                                        setsortType('last_name+desc');
                                                                    } else if (sortType === 'last_name+desc') {
                                                                        setsortType('last_name+asc');
                                                                    } else { setsortType('last_name+asc'); }
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-1 px-1  min-w-[152px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Role
                                                        <a href="#" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'roles+asc' ? 180 : 0,
                                                                }}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                // className={`${sortType === 'roles' ? 'image-rotate' : ''}`}
                                                                onClick={() => {
                                                                    if (sortType === 'roles+asc') {
                                                                        setsortType('roles+desc');
                                                                    } else if (sortType === 'roles+desc') {
                                                                        setsortType('roles+asc');
                                                                    } else { setsortType('roles+asc'); }
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 min-w-[200px] max-w-[300px] ">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Territory
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 min-w-[250px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center whitespace-nowrap">
                                                        Reporting Manager
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 min-w-[140px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Status
                                                        <a href="#" className="pl-[5px]">
                                                            <motion.img
                                                                animate={{
                                                                    rotate: sortType === 'admin_status+asc' ? 180 : 0,
                                                                }}
                                                                // className={`${sortType === 'status' ? 'image-rotate' : ''}`}
                                                                src="/images/sort.svg"
                                                                alt="icon"
                                                                onClick={() => {
                                                                    if (sortType === 'admin_status+asc') {
                                                                        setsortType('admin_status+desc');
                                                                    } else if (sortType === 'admin_status+desc') {
                                                                        setsortType('admin_status+asc');
                                                                    } else { setsortType('admin_status+asc'); }
                                                                }}
                                                            />
                                                        </a>
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 min-w-[166px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Mobile Number
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 min-w-[180px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Email Address
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Activation Date
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 min-w-[200px]">
                                                    <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                        Deactivation Date
                                                    </span>
                                                </th>
                                                <th scope="col" className="py-2.5 px-7 rounded-tr-lg rounded-br-lg min-w-[100px] sticky top-0 right-0 bg-[#555259]" />
                                            </tr>
                                        </motion.thead>
                                    </AnimatePresence>
                                    <>
                                        {UsersList.users && Object.keys(UsersList).length > 0 && UsersList?.users?.Items.length > 0 && (
                                            <ListUsers
                                                setisPaneOpen={setisPaneOpen}
                                                getUserList={getUserList}
                                                userList={UsersList}
                                                setisLoaded={setisLoaded}
                                                currentPage={currentPage}
                                                totalPage={totalPage}
                                                setCurrentPage={setCurrentPage}
                                                setrender={setrender}
                                                setEditDAte={setEditDAte}
                                                render={render}
                                                seteditpaneopen={seteditpaneopen}
                                                EditDAte={EditDAte}
                                                handleSort={handleSort}
                                                setsort={setsort}
                                                sort={sort}
                                                setsortType={setsortType}
                                                filter={filter}
                                                OpenPopup={OpenPopup}
                                                setOpenPopup={setOpenPopup}
                                                handleActivateOrDeactivate={handleActivateOrDeactivate}
                                                actvloader={actvloader}
                                                setactvloader={setactvloader}
                                                isEditId={isEditId}
                                                setisEditId={setisEditId}
                                                isLoaded={isLoaded}
                                                updateuserprevilegeassigned={updateuserprevilegeassigned}
                                                activateDeactivateprevilegeassigned={activateDeactivateprevilegeassigned}
                                                resetprevilegeassigned={resetprevilegeassigned}
                                                manageUserList={manageUserList}
                                                setManageUserList={setManageUserList}
                                                isUserList={isUserList}
                                                setIsUserList={setIsUserList}
                                            />
                                        )}

                                    </>

                                </table>
                            )}
                            <>
                                <>
                                    {UsersList?.users?.Items?.length === 0 && (
                                        <EmptyScreen
                                            text="No Internal Users"
                                            // url="/manage-internal-users/create-admin-user"
                                            // action="Create New"
                                            // title="Internal Users"
                                            // search={searchValue}
                                        />
                                    )}
                                </>
                            </>

                        </>

                    ) : <ItemSkeleton />}

            </div>
            <SlidingPane
                from="right"
                isOpen={filter}
                width="501px"
                className="z-50"
                hideHeader
                onRequestClose={() => setfilter(false)}

            >
                <FilterModal
                    filter={filter}
                    setfilter={setfilter}
                    threePL={threePL}
                    territaryList={territaryList}
                    managers={managers}
                    handleFiletr={handleFiletr}
                    selected={selected}
                    setselected={setselected}
                    rolesData={rolesData}
                    setRolesData={setRolesData}
                />

            </SlidingPane>
            <>
                { UsersList.users && Object.keys(UsersList.users).length > 0 && UsersList.users.number_of_pages > 1 && (
                    <Pagination handlePageClick={handlePageClick} List={UsersList} currentPage={currentPage} />
                )}
            </>
        </>
    );
}
const mapState = (state) => {
    const { UsersList, AdminUserPagination } = state;
    return { UsersList, AdminUserPagination };
};
const createActors = {
    getUserList: UserActions.UserList,
    SortUser: UserActions.SortUser,
    handlePagination: UserActions.AdminPaginationMethod,
};
const connectAdminUsers = connect(mapState, createActors)(AdminUsers);

export { connectAdminUsers as AdminUsers };
